import { useQuery } from '@tanstack/react-query'
import { CUSTOM_DOMAIN_QUERY_KEY, getCustomDomain } from '@/api/services/custom-domain.service'

/**
 * Whether custom domains are live on this environment: the API reports a
 * target only when CUSTOM_DOMAIN_TARGET is set, the same switch that keeps the
 * feature inert and hides it on the plan cards. False while loading or on
 * error, so the section never appears for a feature that may be off.
 */
export function useCustomDomainsAvailable(): boolean {
  const { data } = useQuery({ queryKey: CUSTOM_DOMAIN_QUERY_KEY, queryFn: getCustomDomain })
  return Boolean(data?.target)
}
